import { VariableAutocomplete } from "design-system/molecules/VariableAutocomplete"
import { useVaultEntriesQuery } from "modules/settings/hooks/useVaultEntriesQuery"
import { ComponentProps } from "react"

type Props = ComponentProps<typeof VariableAutocomplete>

export function VaultVariableAutocomplete({ variables, ...props }: Props) {
  const { data: entries } = useVaultEntriesQuery()
  const vaultVariables =
    entries?.map((entry) => ({
      value: `vault.${entry.key}`,
      label: `vault.${entry.key}`,
    })) ?? []

  return <VariableAutocomplete {...props} variables={[...variables, ...vaultVariables]} />
}
